import {
  APPLY_LEAVE,
  APPLY_LEAVE_US,
  APPLY_LEAVE_SQE,
  API_LEAVE_WITHDRAW,
  API_LEAVE_WITHDRAW_US,
  API_LEAVE_WITHDRAW_SQE,
  LEAVE_APPROVE_MANAGER,
  LEAVE_APPROVE_MANAGER_US,
  API_LEAVE_APPROVE_SQE,
} from "../../../config/Endpoints";
import { LeaveSegment } from "./leave-segments";

/** Default India balance tiles; only Exceeded WFH uses danger styling. */
export const DEFAULT_LEAVE_BALANCE_CARDS = [
  { key: "workFromHomeLeave", label: "Work From Home", icon: "home" },
  { key: "privilegeLeave", label: "Privilege Leave", icon: "calendar" },
  { key: "casualLeave", label: "Casual Leave", icon: "calendar" },
  { key: "unpaidLeaveBalanceMonth", label: "Unpaid Leave (MTD)", icon: "wallet" },
  { key: "unpaidLeaveBalanceYear", label: "Unpaid Leave (YTD)", icon: "wallet" },
  {
    key: "negativeBalance",
    label: "Exceeded WFH",
    icon: "alert",
    tone: "danger",
  },
];

/** SQE Labs — quarterly + privilege + unpaid only. */
export const SQE_LEAVE_BALANCE_CARDS = [
  { key: "quartelyLeave", label: "Quarterly Leave", icon: "calendar" },
  { key: "privilegeLeave", label: "Privilege Leave", icon: "calendar" },
  { key: "shortLeave", label: "Short Leave", icon: "calendar" },
  { key: "workFromHomeLeave", label: "Work From Home", icon: "home" },
  { key: "unpaidLeaveBalanceMonth", label: "Unpaid Leave (MTD)", icon: "wallet" },
  { key: "unpaidLeaveBalanceYear", label: "Unpaid Leave (YTD)", icon: "wallet" },
];

export const LEAVE_SEGMENT_CONFIG = {
  [LeaveSegment.DEFAULT]: {
    applyEndpoint: APPLY_LEAVE,
    withdrawEndpoint: API_LEAVE_WITHDRAW,
    approveEndpoint: (id) => `${LEAVE_APPROVE_MANAGER}/${id}/approve`,
    rejectEndpoint: (id) => `${LEAVE_APPROVE_MANAGER}/${id}/reject`,
    minDateRule: "monthStart",
    balanceCards: DEFAULT_LEAVE_BALANCE_CARDS,
  },
  [LeaveSegment.US]: {
    applyEndpoint: APPLY_LEAVE_US,
    withdrawEndpoint: API_LEAVE_WITHDRAW_US,
    approveEndpoint: LEAVE_APPROVE_MANAGER_US,
    rejectEndpoint: LEAVE_APPROVE_MANAGER_US,
    minDateRule: "yearStart",
    balanceCards: DEFAULT_LEAVE_BALANCE_CARDS,
  },
  [LeaveSegment.SQE]: {
    applyEndpoint: APPLY_LEAVE_SQE,
    withdrawEndpoint: API_LEAVE_WITHDRAW_SQE,
    approveEndpoint: (id) => `${API_LEAVE_APPROVE_SQE}/${id}/approve`,
    rejectEndpoint: (id) => `${API_LEAVE_APPROVE_SQE}/${id}/reject`,
    minDateRule: "monthStart",
    balanceCards: SQE_LEAVE_BALANCE_CARDS,
  },
};

export function getLeaveSegmentConfig(segment) {
  return LEAVE_SEGMENT_CONFIG[segment] ?? LEAVE_SEGMENT_CONFIG[LeaveSegment.DEFAULT];
}
